import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import { Fancybox } from "@fancyapps/ui";
// import LocomotiveScroll from 'locomotive-scroll';


$ = jQuery;

$(document).ready(()=>{



	if(document.querySelector('body[data-scroll-container]')) {
		let scroll = new LocomotiveScroll({
			el: document.querySelector('body[data-scroll-container]'),
			smooth: true,
	
			lerp: 0.03, // Linear Interpolation, 0 > 1 // Try 0.01
			multiplier: 1.4, // Effect Multiplier
			reloadOnContextChange: true,
			touchMultiplier: 1,
			smoothMobile: 0,
			smartphone: {
				smooth: !0,
				breakpoint: 768
			},
			tablet: {
				smooth: !1,
				breakpoint: 1024
			},
		});

		// window.addEventListener('scroll', () => {
		// 	scroll.update();
		// });
	}
	
	// window.addEventListener('scroll', () => {
	// 	scroll.update();
	// });

	$('.slider2').slick({
		fade:true,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
		pauseOnHover:false,
		adaptiveHeight: true
    });
    
    $(".carousel-arrows .left2").click( () => {
		$(".slider2").slick('slickPrev');
	});

	$(".carousel-arrows .right2").click( () => {
		$(".slider2").slick('slickNext');
	});

	$('.slider3').slick({
        dots: false,
        arrows: false,
        autoplay: true,
		infinite:true,
        autoplaySpeed: 4000,
		pauseOnHover:false,
		adaptiveHeight: true,
		slidesToShow: 2,
		slidesToScroll: 1,
    });

	$('.slider4').slick({
        dots: true,
        arrows: false,
        autoplay: true,
		infinite:true,
        autoplaySpeed: 4000,
		pauseOnHover:false,
		adaptiveHeight: true,
		slidesToShow: 1,
		slidesToScroll: 1,
    });

	$(".student-slider").slick({
		dots: false,
		arrows: false,
		//fade: true,
		asNavFor: '.box .slider',
		infinite: true
	});

	$(".box .slider").slick({
		dots: true,
		arrows: false,
		fade: false,
		asNavFor: '.student-slider',
		infinite: true
	});
	
	const navigator = document.querySelector("nav");
	document.querySelector(".nav-btn").addEventListener("click", ()=> navigator.classList.add('show'));
	document.querySelector(".close-menu").addEventListener("click", ()=> navigator.classList.remove('show'));

	const hideTabs = () => document.querySelectorAll(".block").forEach( item => item.classList.remove("show"));
	
	const showSelectedTab = tab => document.querySelector(`.block.item-${tab}`).classList.add("show");

	document.querySelectorAll(".block .btn").forEach( btn => btn.addEventListener('click', () => {
		hideTabs();
		showSelectedTab(btn.text);
	}));

	$("#select").dropkick();


	if(document.querySelectorAll('.carrerasCiclos')){
		// let ButtonsCarreras = document.querySelectorAll('.carrerasCiclos');
		// let buttonSelected = '';

		// ButtonsCarreras.forEach(function(buttonSelected){
		// 	buttonSelected.addEventListener('click', ()=> buttonSelected.classList.add('active'));
		// });

		let ButtonsCarreras = document.querySelectorAll('.carrerasCiclos');

		ButtonsCarreras.forEach(function(button) {
			button.addEventListener('click', function() {
				// Remover la clase 'active' de todos los botones
				ButtonsCarreras.forEach(function(btn) {
					btn.classList.remove('active');
				});

				// Agregar la clase 'active' al botón que fue clickeado
				button.classList.add('active');
			});
		});
	}

	Fancybox.bind("[data-fancybox]", {
	// Your custom options
	});
	
});

//Reduce Header
const header = document.querySelector("header");

window.addEventListener('scroll', () => (window.scrollY > 150) ? header.classList.add('reduce_header') :  header.classList.remove('reduce_header'));
//Reduce Header

if(document.querySelector(".carrerasCiclosButtons")){
//fixed buttons

const buttonsNav = document.querySelector(".carrerasCiclosButtons");

window.addEventListener('scroll', () => (window.scrollY > 365) ? buttonsNav.classList.add('fixed') :  buttonsNav.classList.remove('fixed'));
//fixed buttons
}
window.addEventListener('resize', () => header.classList.remove('show'));

// if(document.getElementById("select")){
//   document.getElementById("select").addEventListener("change", function() {
//     let select = this;
//     let value = select.value;
//     if (value != "") { 
//         location.href = value; 
//     }
//   });
// }

if(document.getElementById('select')){
	let selectElement = document.getElementById('select');
	let posts = document.querySelectorAll('.container-list .item');

	selectElement.addEventListener('change', function() {
		let selectedCategory = this.value;

		posts.forEach(function(post) {
			if (selectedCategory === "") {
				post.style.display = 'flex';
			} else {
				if (post.classList.contains('category-' + selectedCategory)) {
					post.style.display = 'flex';
				} else {
					post.style.display = 'none';
				}
			}
		});
	});
}


//accordeon

let showAccordeon = function(elem, height) {
    elem.parentElement.classList.add('show');
    elem.style.height = height + "px";
};

let closeAccordeon = function(elem) {
    elem.parentElement.classList.remove('show');
    elem.style.height = "0px";
};

if (document.querySelector(".accordeon")) {
    document.querySelector(".accordeon").addEventListener('click', function(elem) {
        let show = elem.target.parentElement.classList.contains("show");
        if (!show) {
            showAccordeon(elem.target.nextElementSibling, elem.target.nextElementSibling.scrollHeight);
        } else {
            closeAccordeon(elem.target.nextElementSibling);
        }
    });
}

//accordeon